<template>
  <v-container
    grid-list-xl
    text-center
    role="region"
    aria-label="Change password section"
  >
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md12
        lg6
        offset-lg3
      >
        <v-card>
          <v-toolbar
            flat
            color="primary"
            role="heading"
            aria-level="1"
          >
            <v-toolbar-title class="text-body-2">
              {{ $t('components.changePassword.title') }}
            </v-toolbar-title>
          </v-toolbar>

          <v-container
            fluid
            grid-list-md
          >
            <!-- Alerts for validation feedback -->
            <div
              v-for="(errorsGroup, errorsGroupIndex) in filteredErrors"
              :key="errorsGroupIndex"
              role="alert"
              aria-live="polite"
            >
              <v-alert
                v-for="error in errorsGroup"
                :key="error.id"
                :type="error.type"
                :icon="error.icon"
              >
                {{ error.msg }}
              </v-alert>
            </div>

            <v-form
              aria-describedby="change-password-form"
              @submit.prevent="validate"
            >
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.currentPassword"
                    v-validate="'required|min:6|max:50'"
                    prepend-icon="fal fa-key"
                    color="accent"
                    autocomplete="current-password"
                    data-vv-as="current password"
                    data-vv-name="currentPassword"
                    :error-messages="errors.collect('currentPassword')"
                    :label="$t('components.changePassword.form.currentPass')"
                    name="currentPassword"
                    type="password"
                    aria-required="true"
                    aria-label="Current password"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    ref="newPassword"
                    v-model="form.newPassword"
                    v-validate="'required|min:6|max:50'"
                    prepend-icon="fal fa-key"
                    color="accent"
                    autocomplete="new-password"
                    data-vv-as="new password"
                    data-vv-name="newPassword"
                    :error-messages="errors.collect('newPassword')"
                    :label="$t('components.changePassword.form.password')"
                    name="newPassword"
                    type="password"
                    aria-required="true"
                    aria-label="New password"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.confirmNewPassword"
                    v-validate="'required|min:6|max:50|confirmed:newPassword'"
                    prepend-icon="fal fa-key"
                    color="accent"
                    autocomplete="new-password"
                    data-vv-as="confirmation of new password"
                    data-vv-name="confirmNewPassword"
                    :error-messages="errors.collect('confirmNewPassword')"
                    :label="$t('components.changePassword.form.confirmPass')"
                    name="confirmNewPassword"
                    type="password"
                    aria-required="true"
                    aria-label="Confirm new password"
                  />
                </v-flex>
              </v-layout>

              <v-progress-linear
                v-show="isLoading"
                color="accent"
                indeterminate
                role="progressbar"
                aria-label="Submitting form"
              />

              <v-btn
                :aria-label="$t('components.changePassword.buttons.change')"
                color="accent"
                type="submit"
              >
                {{ $t('components.changePassword.buttons.change') }}
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { filterByKeys } from "@/utils/object.utils";
import Validator from "@/modules/validator.module";
import blacklist from "@/constants/blacklist";

const ValidatorModule = new Validator();

export default {
  name: "ChangePassword",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ValidationProvider
  },
  inject: ["$validator"],
  data() {
    return {
        form: {
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: ""
        },
        isLoading: false
    }
  },
  computed: {
    filteredErrors() {
      return filterByKeys(
        this.$validator.errors.collect(),
        blacklist.forms.changePassword
      );
    }
  },
  methods: {
    validate() {
      this.isLoading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$api.changePassword(
            this.form.currentPassword,
            this.form.newPassword
          )
            .then(res => {
              this.isLoading = false;
              // Add to the validator
              ValidatorModule.add("changedPass", res);
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    }
  }
};
</script>
